import React from "react"

const AffiliateDisclaimer = () => (
  <p>
    <em>
      Some of these links are “affiliate links”. If you click and buy through
      them we get a small commission – at no extra cost of yours. It’s an easy
      and free way to support Athlegan! Of course, we only recommend services
      and products that we truly like and use ourselves.
    </em>
  </p>
)

export default AffiliateDisclaimer
